import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../services/loginService";
import "../styles/pages/login_page.css";

import logo from "../assets/icons/logo.svg";

const LoginPage = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const isDisabled = !username || !password;

  const handleLogin = async (event) => {
    event.preventDefault();
    try {
      const data = await loginUser(username, password);
      if (data && data.accessToken) {
        localStorage.setItem("accessToken", data.accessToken);
        navigate("/news");
      } else {
        setError("Ошибка: Некорректный ответ сервера");
      }
    } catch (err) {
      if (err.response) {
        if (err.response.status === 400) {
          setError("Ошибка входа: Неверный логин или пароль");
        } else {
          setError(
            `Ошибка входа: ${err.response.data.message || "Попробуйте снова"}`
          );
        }
      } else {
        setError("Ошибка: Некорректный ответ сервера");
      }
      console.error("Login error:", err);
    }
  };

  return (
    <div className="login-page">
      <div className="login-bg" />
      <div className="login-overlay" />
      <div className="login-container">
        <img src={logo} alt="Логотип" className="login-logo" />

        {error && <p className="error-message">{error}</p>}

        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="login" className="field-label">
              Логин
            </label>
            <input
              id="login"
              type="text"
              className="text-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Введите логин администратора"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="field-label">
              Пароль
            </label>
            <input
              id="password"
              type="password"
              className="text-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Введите пароль администратора"
            />
          </div>

          <button
            type="submit"
            className={`login-button ${isDisabled ? "disabled" : ""}`}
            disabled={isDisabled}
          >
            Войти
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
